export default __webpack_public_path__ + "static/KhanjiPir-32ea3fc1e50333f27f052fc3bba3f5e8.jpg";